module.exports = {
      id: "eye-off-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#eye-off",
      toString: function () {
        return this.url;
      }
    }